(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumb"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const collectionBreadcrumb = document.getElementById('collection-breadcrumb');
    const breadcrumbMobile = document.getElementById('breadcrumb-mobile');

    if (document.referrer != undefined && document.referrer.includes('collection')) {
      if (productCollections.length > 0 && metafieldBreadcrumbCollection == null) {
        // get collection handle from referrer url
        const collectionHandle = document.referrer.split('/').pop();

        // match collection with handle from productCollections
        const collection = productCollections.find((collection) => collection.handle === collectionHandle);

        // set collection breadcrumb
        collectionBreadcrumb.href = '/collections/' + collectionHandle;
        collectionBreadcrumb.textContent = collection.title.replace(/^[0-9]+\./, '');

        // set mobile breadcrumb
        breadcrumbMobile.querySelector('a').href = '/collections/' + collectionHandle;
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
